import { render, staticRenderFns } from "./dzcsq.vue?vue&type=template&id=1568de1c&scoped=true&"
import script from "./dzcsq.vue?vue&type=script&lang=js&"
export * from "./dzcsq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568de1c",
  null
  
)

export default component.exports